import Link from 'gatsby-link'
import * as React from 'react'

interface IHeaderProps {
  bwlogo?: boolean
}

class Header extends React.PureComponent<IHeaderProps> {
  public render() {
    const {bwlogo} = this.props

    return (
      <header className="header">
        <Link to="/" className="header__logo circlelink">
          <img
            className="header__logo__icon"
            src={require(bwlogo ? '../img/logo__bw.svg' : '../img/logo.svg')}
            alt=""
          />
          Supportive
        </Link>
        <nav className="nav">
          <Link
            className="nav__link circlelink"
            activeClassName="nav__link--active"
            to="/blog"
          >
            News
          </Link>
          <Link
            className="nav__link circlelink"
            activeClassName="nav__link--active"
            to="/about"
          >
            About
          </Link>
        </nav>
      </header>
    )
  }

  private handleContactClick = (e: React.SyntheticEvent<HTMLButtonElement>) => {
    e.preventDefault()

    try {
      if (window && window.drift && typeof window.drift !== 'undefined') {
        window.drift.api.sidebar.open()
        return
      }
    } catch (e) {
      // Open mailing list
      window.open('mailto:hi@wearesupportive.com')
      return
    }

    window.open('mailto:hi@wearesupportive.com')
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.tsx